/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsIdleAzureAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsIdleAzureAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsIdleAzureAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsIdleAzureAdvisorResource>): RecommendationForFinopsIdleAzureAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsIdleAzureAdvisorResource(), model);
        RecommendationForFinopsIdleAzureAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsIdleAzureAdvisorResource>): RecommendationForFinopsIdleAzureAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsIdleAzureAdvisorResource.newInstance(<RecommendationForFinopsIdleAzureAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsIdleAzureAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsIdleAzureAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsIdleAzureAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsIdleAzureAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
